import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { RpmStatusTriangle } from '../../../../../../../../assets/Logos/Icons'

import heartBeatImage from '../../../../../../../../assets/RpmAssets/PNGIcons/spo2icons.png'
import Spinner from "react-bootstrap/Spinner";
import videoplay from '../../../../../../../../assets/RpmAssets/videoplay.png'
import { Chart } from "react-google-charts";
import moment from 'moment';

function Spo2() {

    let reduxData = useSelector(state => state) ; 
    console.log("Redux Data in RpmProfile: ",reduxData);
    let patientDetails = reduxData.rpmreducer.vitalhistory && 
                            reduxData.rpmreducer.vitalhistory.data.blood_oxigen;
    
    
    console.log(patientDetails)
    const options = {
        title: "",
        //curveType: "function",
        legend: { position: "none" },
        dataLabels: {
            enabled: false
          },
        // hAxis: { textPosition: 'none' },
        // vAxis: { textPosition: 'none' },
        colors: ["#20C4C7"],
        width: "100%",
        lineWidth: 3,
        chartArea: { width: "80%", height: "80%" },
    };
    const convertToGraphData = () => {

        let data = []

        if (patientDetails && patientDetails.length > 0) {

            data.push(["Date", "Reading"],)
            patientDetails.forEach(element => {

                data.push( [moment(element.date,'DD/MM/YYYY h:mm:ss A').format("DD-MMM"), Number(element.blood_oxygen)],)


            });
        }

        console.log(data);

        return data



    }
    useEffect(() => {
       
       
       
      },[])
    return (
        <div className='blood-pressure-vital-container'>

            <div className="blood-pressure-vital-container_details">
            {patientDetails!=undefined && patientDetails.length>0?(
                <ul className='patient-vitals-list'>
                    {
                        patientDetails.map((element,key) => {
                            return (
                                <li className={key===0&&'patient-vitals-list_active'} key={key}>


                                    <div className="left">
                                        <img src={heartBeatImage} alt="" />

                                        <span className='item'> Oxygen </span>

                                        {/* <div className="icon">
                                            <Spo2 variant="abnormal" size="13" />
                                        </div> */}

                                        <span className='value'>{element.blood_oxygen}</span>
                                        <span className='unit'>%</span>
                                        
                                    </div>
                                    <div className="left">
                                        {element.blood_oxygenvideo!=''&&
                                                <a href={element.blood_oxygenvideo} target="_blank">  <img src={videoplay} alt="" /></a>
                                            }
                                    </div> 
                                    <div className="left">

                                        <span className='unit'>as on {element.date}</span>
                                    </div>
                                </li>
                            )
                        })
                    }
                </ul>
            ):patientDetails == undefined ? (
                <div className='loader'>
                    {/* ****IMPORTANT Loader is not working */}
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                </div>):"No Data Available"}
            </div>
           {/*  { patientDetails.length>=3?(
            <div className="blood-pressure-vital-container_graph">

                <span className="title">Last 10 readings</span>

                <div className="dummy-graph">
                    <Chart
                        chartType="LineChart"
                        width="100%"
                        height="100%"
                        data={convertToGraphData()}
                        options={options}
                    />
                </div>
                </div> 
            ):""} */}


        </div>
    )
}

export default Spo2